import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { DataManager } from '@syncfusion/ej2-data';
import { DialogModel } from '@syncfusion/ej2-angular-popups';  // remove

import { CerUiPromptProviderService, createDialogElement as createPromptElement } from '@ui/cer-ui-prompt-provider.service';
import { CerDropDownList } from 'src/cer/cer-control/cer-drop-down-list/cer-drop-down-list';

import { CerSessionService } from '@cer/cer-session/cer-session.service';
import { CerLocaleService } from './cer-ui-locale.service';
import { CerAppDialogErrorApi } from './cer-ui-dialog-error-api';
import { CerAppRouteService } from 'src/cer-app/cer-app-route/cer-app-route.service';

import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormDialogComponent } from '@cer/cer-form/cer-form-dialog/cer-form-dialog.component';
import { CerDateTimeEdit } from '@cer/cer-control/cer-date-edit/cer-date-edit';
import { FileResponse } from '@app/api';
import { CerFormDataNavigation } from '@cer/cer-form/cer-form-navigation.service';

export class PromptFormOptions {
  //  public formModelAdapter?: typeof CerAppFormModelAdapter;
  public data?: any;
}

export type PromptAction = 'clickOnly' | 'ok' | 'cancel' | /*'yes' | 'no' | */'close' | 'edit' | 'retry' | 'reset' | 'ignore' | 'continue' | 'reload' | 'copy' | 'paste' | 'help' | 'clientVersionMismatch';

export type PromptType = 'silent' | 'toast' | 'confirm' | 'info' | 'warning' | 'error';

export class PromptOptions {
  public dataNavigation?: CerFormDataNavigation;
  public type?: PromptType;
  public content?: string;
  public inputs?: PromptInput[];
  public title?: string;
  public defaultAction?: PromptAction;
  public dialogArgs?: DialogModel;
  public buttons?: PromptButton[];
  public toastDuration?: number;
  public errorAppVersion?: string;
}

export class PromptResult {
  public action: PromptAction;
  public inputs?: PromptInput[];
  public result?: any;
  public error?: any;

  constructor(options?: Partial<PromptResult>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

// Button
export type PromptButtonClick = (e: any) => void;

export class PromptButton {
  public text: string;
  public iconCss?: string;
  public click?: PromptButtonClick;
  public submit?: boolean;
  public action: PromptAction; // Ok = Submits
}

export function clipboardWriteText(value: string) {
  navigator.clipboard.writeText(value);
}

// Input
export class PromptInput {
  id: string;
  sourceObject?: any;
  label: string;
  placeholder: string;
  value?: string;
  valueNumber?: number;
  valueDate?: Date;
  element: HTMLElement;
  type?: 'DropDownList' | 'CheckBox' | 'DateTime' | 'Input';
  dataSource?: object[];
  fields?: any;
  ej2?: any;
  maxLen?: number;
  disabled?: boolean;
}

export function promptInputAdd(i: PromptInput, txtDiv: HTMLDivElement) {
  if (i.label) {
    var lbl: any = createEle('label', { innerText: i.label, className: 'dialog-field' });
    var input: any = createEle('input', { id: i.id, placeholder: i.placeholder });
    i.element = input;
    if (i.disabled === true) {
      input.disabled = true;
    }
    if (i.type == 'CheckBox') {
      input.type = 'checkbox';
      input.classList.add('e-boolcell');
      input.classList.add('e-control');
      input.classList.add('e-checkbox');
      if (i.valueNumber == 1) {
        input.checked = true;
      }
    }
    else {
      input.type = 'text';
      input.classList.add('e-input');
      input.value = i.value ?? '';
    }
    lbl.appendChild(input);
    if (i.type) {
      switch (i.type) {
        case 'DropDownList':
          var options = {};
          var DDL = new CerDropDownList(options);
          DDL.fields = i.fields ? i.fields : { text: 'name', value: 'id' };
          DDL.allowFiltering = true;
          DDL.showClearButton = true;
          DDL.dataSource = new DataManager(i.dataSource);
          DDL.appendTo(input);
          i.ej2 = DDL;
          DDL.value = i.valueNumber ?? i.value;
          break;
        case 'DateTime':
          var options = {};
          var dtEdit = new CerDateTimeEdit(options);
          dtEdit.showClearButton = true;
          dtEdit.appendTo(input);
          i.ej2 = dtEdit;
          dtEdit.value = i.valueDate;
          break;
        case 'Input':
          input.text = i.value;
          break;
      }
    }
    txtDiv.append(lbl);
  }
}

export function promptInputValueSet(i: PromptInput) {
  if (i?.element == null) {
    return;
  }
  if (i.type == 'CheckBox') {
    i.valueNumber = (<any>i.element).checked;
  }
  else if (i.ej2 != null) {
    switch (i.type) {
      case 'DateTime':
        i.valueDate = (<any>i.ej2).value;
        break;
      default:
        i.value = (<any>i.element).value;
    }
  }
  else {
    i.value = (<any>i.element).value;
  }
}

// DOM Element
export interface IElementOptions {
  id?: string;
  className?: string;
  innerHTML?: string;
  styles?: string;
  attrs?: {
    [key: string]: string;
  };

  src?: string;

  innerText?: string;
  placeholder?: string;
  type?: string;
  accept?: string;
}

export function createEle(tagName: string, options?: IElementOptions, parent: HTMLElement = null): HTMLElement {
  return createPromptElement(tagName, options, parent);
}

/*
export function refreshEvent(event: UiCommandEvent) {
  if (event?.appComponent != null) {
    refreshComponent(event.appComponent);
  }
}
 
export function refreshComponent(appComponent: Object) {
  if (appComponent != null && appComponent.hasOwnProperty('research')) {
    (<any>appComponent).research();
  }
}
 
export function numGetFromEventRowData(event: UiCommandEvent): string {
  return event?.rowData?.num;
}
 
export function numsFromEventRowDataGet(event: UiCommandEvent): string[] {
  var num: string = numGetFromEventRowData(event)
  return num ? [num] : [];
}
 
export function numsFromEventRowsDataGet(event: UiCommandEvent): string[] {
  var nums: string[] = [];
  if (event?.appComponent != null) {
    var appComponent: CerGridComponent = <CerGridComponent>event.appComponent;
    if (appComponent) {
 
      appComponent.rowsSelectedData().forEach(rowData => {
        var dto: any = <any>rowData;
        if (dto?.num) {
          nums.push(dto.num);
        }
      });
    }
  }
  return nums;
}
 
*/

@Injectable({
  providedIn: 'root'
})
export class CerPromptService {

  public downloadFile(file: FileResponse) {
    if (file?.data == null) {
      return;
    }
    const fileName = decodeURI(file.fileName);
    const url = window.URL.createObjectURL(new Blob([file.data]));
    this.downloadUrl(url, fileName);
    window.URL.revokeObjectURL(url);
  }

  public downloadUrl(url: string, fileName: string = null)  {
    const a = document.createElement('a');
    a.href = url;
    a.download = url.split('/').pop()
    if (fileName?.length > 0) {
      a.setAttribute('download', fileName);
    }
    document.body.appendChild(a);
    a.click();
    a.remove();a
  }

  constructor(
    private sessionService: CerSessionService,
    private routeService: CerAppRouteService,
    private localeService: CerLocaleService,
    private dlg: CerUiPromptProviderService,
    private matDialog: MatDialog) { }


  // Generic prompt modal + toast + silent
  public async prompt(setup: PromptOptions): Promise<PromptAction> {
    switch (setup.type) {
      case 'silent':
        return setup.defaultAction;
      case 'toast':
        this.toast(setup.content, setup.title, setup.toastDuration);
        return setup.defaultAction;
      case 'warning':
        return await this.warning(setup.content, setup.title);
      case 'error':
        return await this.error(setup.content, setup.title);
      default:
        return await this.info(setup.content, setup.title);
    }
  }

  // Operation flow
  private operationToastMsg: string | string[] = null;
  public operationBegin(msg?: string | string[], title?: string) {
    this.operationToastMsg = msg;
    if (msg?.length > 0) {
      this.stickyToast(msg, title);
    }
    this.routeService.setIsLoading(true);
  }
  
  public operationProgress(msg?: string | string[], title?: string) {
    this.operationToastMsg = msg;
    if (msg?.length > 0) {
      this.stickyToast(msg, title);
    }
  }

  public operationEndError(error: any, toastError: string | string[] = null): Promise<PromptAction> {
    this.operationEnd(this.operationToastMsg);
    if (toastError?.length > 0 || this.operationToastMsg?.length > 0) {
      this.errorToast(toastError ?? this.operationToastMsg);
    }
    return this.errorApiAction(error);
  }

  public operationEnd(toastText: string | string[] = null, hide: boolean = false) {
    this.routeService.setIsLoading(false);
    if (!hide && (toastText?.length > 0 || this.operationToastMsg?.length > 0)) {
      this.toast(toastText ?? this.operationToastMsg, "Afsluttet");
    } else {
      this.hideToast();
    }
  }

  // Toast messages
  public toast(message: string | string[], title: string = null, duration: number = 4000, callBack: any = null) {
    var content: string = this.localeService.textToHtml(message);
    this.dlgToast(content, title, duration, callBack);
  }

  public hideToast() {
    this.dlg.toastHide();
  }

  public stickyToast(message?: string | string[], title?: string) {
    this.dlgToast(message, title ?? "Vent venligst ...", 0);
  }

  public dlgToast(message: string | string[], title: string, duration: number, callBack: any = null) {
    var content: string = this.localeService.textToHtml(message);
    this.dlg.toast(content, title, duration, callBack);
  }

  public completedToast(message?: string | string[], title: string = null, duration: number = 2000) {
    this.toast(message, title ?? "Fuldført", duration);
  }

  public infoToast(message?: string | string[], title: string = null, duration: number = 4000) {
    this.toast(message, title ?? "Information", duration);
  }

  public warningToast(message?: string | string[], title: string = null, duration: number = 4000) {
    this.toast(message, title ?? "Advarsel", duration);
  }

  public errorToast(message?: string | string[], title: string = null, duration: number = 4000) {
    this.toast(message, title ?? "Fejl", duration);
  }

  // Modal prompts
  public async error(content: string | string[] | HTMLElement, title: string = null, options: PromptOptions = null): Promise<PromptAction> {
    return await this.dlgPrompt(content, title ?? "Fejl");
  }

  public async warning(content: string | string[] | HTMLElement, title: string = null, options: PromptOptions = null): Promise<PromptAction> {
    return await this.dlgPrompt(content, title ?? "Advarsel", options);
  }

  public async info(content: string | string[] | HTMLElement, title: string = null, options: PromptOptions = null): Promise<PromptAction> {
    return await this.dlgPrompt(content, title ?? "Information", options);
  }

  public async confirm(content: string | string[] | HTMLElement, title: string = null, options: PromptOptions = null): Promise<PromptAction> {
    options ??= {}
    options.defaultAction ??= 'ok';
    options.buttons ??= [];
    options.buttons = ([CerUiPromptProviderService.promptBtnOk, CerUiPromptProviderService.promptBtnCancel]).concat(options.buttons);
    return await this.dlgPrompt(content, title ?? "Bekræft", options);
  }

  private async dlgPrompt(content: string | string[] | HTMLElement, title: string, options: PromptOptions = null): Promise<PromptAction> {
    return await this.dlg.prompt(content, title, options);
  }

  public promptHide() {
    this.dlg.promptHide();
  }

  public promptSetPosition() {
    this.dlg.promptSetPosition();
  }

  /*
  public async dialog(txt: string | string[], title: string = null): Promise<PromptAction> {
    return this.dlg.prompt(txt, title ?? "Meddelelse");
  }
  */

  // Open document
  public openFileToast(fileName: any) {
    if (fileName?.length > 0) {
      this.toast('Dokument', 'Vis dokument', 7000, () => { window.open(fileName, '_blank') });
    }
    else {
      this.errorToast('Intet dokument tilgængeligt');
    }
  }

  // Format 
  public formatDateTime(d: Date): string {
    return this.localeService.formatDateTime(d);
  }

  // Prompt input
  public promptInputsDdl(bodyHeader: string, title: string = "Angiv værdi", inputs: PromptInput[], buttons: PromptButton[] = []): Promise<PromptResult> {
    return new Promise<PromptResult>(resolve => {
      this.promptInputs(bodyHeader, title, inputs, buttons).then(res => {
        inputs.filter(i => i.type == 'DropDownList' && i.ej2).forEach(i => {
          const ddl = i.ej2 as CerDropDownList;
          if (ddl) {
            i.value = ddl.value as string;
          }
        });
        resolve(res);
      });
    });
  }

  public promptInputs(bodyHeader: string, title: string = "Angiv værdi", inputs: PromptInput[], buttons: PromptButton[] = []): Promise<PromptResult> {
    var content: string = bodyHeader;

    var promise = new Promise<PromptResult>(resolve => {
      const options = {
        defaultAction: 'ok',
        buttons: buttons
      } as PromptOptions;

      this.confirm(content, title, options).then(
        action => {
          if (inputs) {
            for (let i of inputs) {
              promptInputValueSet(i);
            }
          }
          resolve({
            action: action,
            inputs: inputs
          } as PromptResult);
        });
    });
    var txtDiv: HTMLDivElement = this.dlg.getDialogContent();
    if (txtDiv && inputs?.length > 0) {
      txtDiv.classList.add('flex-column');
      txtDiv.classList.add('dialog-text');
      for (var i of inputs) {
        promptInputAdd(i, txtDiv);
      }
      this.promptSetPosition();
    }

    return promise;
  };

  // API error handling
  public errorApi(e: any, operation: string = null, status: number = null) {
    this.errorApiAction(e, operation, status).then(action => { });
  }

  public async errorApiAction(e: any, operation: string = null, status: number = null): Promise<PromptAction> {
    var setup: PromptOptions = await CerAppDialogErrorApi.Setup(e, operation, status);
    var action = setup.defaultAction;
    if (action == 'clientVersionMismatch') {
      if (this.sessionService.environment.clientNeedsReload$.getValue() !== true) {
        this.sessionService.environment.onAppVersion(setup.errorAppVersion);
      }
      setup.type = 'silent'; // already hanndled
    }

    if (setup.type != 'silent') {
      action = await this.prompt(setup);
    }
    return action;
  }

  private appReload() {
    this.errorToast("App genlæses", "Manglende adgang", 1000);
    setTimeout(() => { this.routeService.reloadForcedUrl() }, 1000);
  }

  // Form dialogs
  public showDataNavigationAsDialog(dataNavigation: CerFormDataNavigation, formOptions: PromptFormOptions = null): Promise<PromptResult> {
    if (!formOptions) {
      formOptions = new PromptFormOptions();
    }
    var data: any = formOptions?.data ? formOptions.data : {};
    data.dataNavigation = dataNavigation;
    return this.showDialogComponent(CerFormDialogComponent, null, data);
  }

  public showFormAsDialog(formAdapterType: typeof CerFormAdapter, formOptions: PromptFormOptions = null): Promise<PromptResult> {
    if (!formOptions) {
      formOptions = new PromptFormOptions();
    }
    var data: any = formOptions?.data ? formOptions.data : {};
    if (formAdapterType) {
      data.formAdapterType = formAdapterType;
    }
    return this.showDialogComponent(CerFormDialogComponent, null, data);
  }

  public showDialogComponent(component: any /* typeof "Component" */, config: MatDialogConfig = null, dialogOptions: PromptOptions = null): Promise<PromptResult> {
    return new Promise<PromptResult>(resolve => {
      try {
        if (!config) {
          config = { width: '90vw', height: '90vh', maxWidth: '90vw', disableClose: true, data: dialogOptions }
        };
        var dlg = this.matDialog.open(component, config);
        if (dialogOptions?.dataNavigation) {
          const dlgForm = dlg.componentInstance as CerFormDialogComponent;
          if (dlgForm) {
            dlgForm.dataNavigation = dialogOptions.dataNavigation;
          }
        }
        dlg.afterClosed().subscribe(result => resolve(new PromptResult({ action: 'ok' })));
        dlg.backdropClick().subscribe(result => resolve(new PromptResult({ action: 'cancel' })));
      }
      catch (e) {
        console.log(e);
        resolve(new PromptResult({ action: 'cancel' }));
      }
    });
  }

  // Dialog full  config
  public matDialogConfigFullScreen(data: any): MatDialogConfig {
    return <MatDialogConfig>{
      width: '98vw', height: '98vh', maxWidth: '98vw', disableClose: true, data: data
    };
  }

}
